import PropTypes from "prop-types";
import Link from "next/link";

export default function NextLink({
  children,
  className,
  domain,
  href,
  ...props
}) {
  const current = domain === "appsignal.com" ? "www.appsignal.com" : domain;
  const isInternalLink = href?.includes(current);

  return isInternalLink ? (
    <Link href={new URL(href).pathname} className={className} {...props}>
      {children}
    </Link>
  ) : (
    <a href={href} className={className} {...props}>
      {children}
    </a>
  );
}

NextLink.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  domain: PropTypes.string,
  href: PropTypes.string,
};
